/* ============================================================
   VOXEL — interaction & motion system
   ============================================================ */
(function () {
  "use strict";
  var root = document.documentElement;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- THEME (auto / system default + persistence) ---------- */
  var STORE = "voxel-theme";
  var systemDark = window.matchMedia("(prefers-color-scheme: dark)");
  function syncThemeLogos(t) {
    document.querySelectorAll("img[data-logo-dark][data-logo-light]").forEach(function (img) {
      var next = t === "dark" ? img.getAttribute("data-logo-dark") : img.getAttribute("data-logo-light");
      if (next) img.setAttribute("src", next);
    });
  }

  function resolved() {
    var saved = null;
    try { saved = localStorage.getItem(STORE); } catch (e) {}
    if (saved === "light" || saved === "dark") return saved;
    return systemDark.matches ? "dark" : "light"; // auto -> system, defaults dark
  }
  function applyTheme(t) {
    root.setAttribute("data-theme", t);
    syncThemeLogos(t);
    var tog = document.querySelector(".theme-toggle");
    if (tog) tog.setAttribute("aria-label", tog.getAttribute(t === "dark" ? "data-label-light" : "data-label-dark") || "Switch theme");
    // Sync 12/24 knob label on the new toggle pattern
    var knobLabel = document.querySelector(".theme-toggle-tt .tt-knob-label");
    if (knobLabel) knobLabel.textContent = (t === "dark") ? "24" : "12";
  }
  applyTheme(resolved());
  systemDark.addEventListener("change", function () {
    var saved = null;
    try { saved = localStorage.getItem(STORE); } catch (e) {}
    if (!saved) applyTheme(systemDark.matches ? "dark" : "light");
  });

  document.addEventListener("DOMContentLoaded", function () {
    var toggle = document.querySelector(".theme-toggle");
    if (toggle) {
      toggle.addEventListener("click", function () {
        var next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
        root.style.setProperty("--t-med", "0.32s");
        applyTheme(next);
        try { localStorage.setItem(STORE, next); } catch (e) {}
      });
    }
    // Ensure knob label reflects current theme on first paint
    (function syncKnob() {
      var knobLabel = document.querySelector(".theme-toggle-tt .tt-knob-label");
      if (knobLabel) knobLabel.textContent = (root.getAttribute("data-theme") === "dark") ? "24" : "12";
    })();

    /* ---------- PAGE VEIL ---------- */
    var veil = document.querySelector(".page-veil");
    if (veil) {
      window.addEventListener("load", function () {
        setTimeout(function () { veil.classList.add("gone"); }, 280);
      });
      setTimeout(function () { veil.classList.add("gone"); }, 1400); // safety
    }

    /* ---------- HEADER ON SCROLL ---------- */
    var header = document.querySelector(".header");
    var progress = document.querySelector(".scroll-progress");
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle("scrolled", y > 24);
      if (progress) {
        var h = document.body.scrollHeight - window.innerHeight;
        progress.style.width = (h > 0 ? (y / h) * 100 : 0) + "%";
      }
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    /* ---------- MOBILE NAV ---------- */
    var navToggle = document.querySelector(".nav-toggle");
    var navMobile = document.querySelector(".nav-mobile");
    if (navToggle && navMobile) {
      navToggle.addEventListener("click", function () {
        var open = navMobile.classList.toggle("open");
        navToggle.classList.toggle("is-open", open);
        navToggle.setAttribute("aria-expanded", open ? "true" : "false");
        document.body.style.overflow = open ? "hidden" : "";
      });
      navMobile.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function () {
          navMobile.classList.remove("open");
          navToggle.classList.remove("is-open");
          document.body.style.overflow = "";
        });
      });
    }

    /* ---------- SCROLL REVEAL ---------- */
    var reveals = document.querySelectorAll(".reveal");
    if ("IntersectionObserver" in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.08, rootMargin: "0px 0px 4% 0px" });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("in"); });
    }

    /* ---------- COUNTERS ---------- */
    function animateCount(el) {
      var target = parseFloat(el.dataset.count);
      var dec = (el.dataset.count.split(".")[1] || "").length;
      var suffix = el.dataset.suffix || "";
      var prefix = el.dataset.prefix || "";
      var group = el.dataset.format !== "plain";
      var dur = 1600, start = null;
      function fmt(v, exact) {
        var s = dec ? v.toFixed(dec) : String(Math.round(v));
        if (group && !dec) s = (exact ? target : Math.round(v)).toLocaleString();
        return prefix + s + suffix;
      }
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased, false);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(target, true);
      }
      requestAnimationFrame(step);
    }
    var counters = document.querySelectorAll("[data-count]");
    if ("IntersectionObserver" in window && !reduced) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { animateCount(en.target); cio.unobserve(en.target); }
        });
      }, { threshold: 0.5 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(function (el) {
        el.textContent = (el.dataset.prefix || "") + el.dataset.count + (el.dataset.suffix || "");
      });
    }

    /* ---------- MAGNETIC BUTTONS ---------- */
    if (!reduced && window.matchMedia("(pointer:fine)").matches) {
      document.querySelectorAll("[data-magnetic]").forEach(function (el) {
        var strength = parseFloat(el.dataset.magnetic) || 0.3;
        el.addEventListener("mousemove", function (e) {
          var r = el.getBoundingClientRect();
          var x = (e.clientX - r.left - r.width / 2) * strength;
          var y = (e.clientY - r.top - r.height / 2) * strength;
          el.style.transform = "translate(" + x + "px," + y + "px)";
        });
        el.addEventListener("mouseleave", function () {
          el.style.transform = "";
        });
      });
    }

    /* ---------- ACCORDION ---------- */
    document.querySelectorAll(".acc-head").forEach(function (head) {
      head.addEventListener("click", function () {
        var item = head.closest(".acc-item");
        var isOpen = item.classList.contains("open");
        item.parentElement.querySelectorAll(".acc-item.open").forEach(function (o) {
          o.classList.remove("open");
          o.querySelector(".acc-head").setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("open");
          head.setAttribute("aria-expanded", "true");
        }
      });
    });

    /* ---------- PARALLAX (subtle, GPU) ---------- */
    var parallax = document.querySelectorAll("[data-parallax]");
    if (parallax.length && !reduced) {
      var ticking = false;
      function px() {
        var vh = window.innerHeight;
        parallax.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var speed = parseFloat(el.dataset.parallax) || 0.12;
          var offset = (r.top + r.height / 2 - vh / 2) * -speed;
          el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
        });
        ticking = false;
      }
      window.addEventListener("scroll", function () {
        if (!ticking) { requestAnimationFrame(px); ticking = true; }
      }, { passive: true });
      px();
    }

    /* ---------- PARTICLES ---------- */
    var pf = document.querySelector(".particles");
    if (pf && !reduced) {
      var n = window.innerWidth < 760 ? 14 : 28;
      for (var i = 0; i < n; i++) {
        var s = document.createElement("span");
        s.style.left = Math.random() * 100 + "%";
        s.style.bottom = "-10px";
        var dur = 14 + Math.random() * 22;
        s.style.animationDuration = dur + "s";
        s.style.animationDelay = -(Math.random() * dur) + "s";
        var sc = 0.4 + Math.random() * 1.4;
        s.style.transform = "scale(" + sc + ")";
        s.style.opacity = 0.2 + Math.random() * 0.6;
        pf.appendChild(s);
      }
    }

    /* ---------- HERO POINTER GLOW ---------- */
    var heroVisual = document.querySelector(".hero-visual");
    if (heroVisual && !reduced && window.matchMedia("(pointer:fine)").matches) {
      var hero = document.querySelector(".hero");
      hero.addEventListener("mousemove", function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        heroVisual.style.transform = "translate3d(" + (x * 18) + "px," + (y * 18) + "px,0)";
      });
      hero.addEventListener("mouseleave", function () {
        heroVisual.style.transform = "";
      });
    }

    /* ---------- SCROLL-DRIVEN LOGO REVEAL ---------- */
    var logoSections = document.querySelectorAll(".logo-scroller");
    if (logoSections.length) {
      function updateLogoScroll() {
        logoSections.forEach(function (sec) {
          var rect = sec.getBoundingClientRect();
          var winH = window.innerHeight;
          var total = sec.offsetHeight - winH;
          var prog = total > 1
            ? Math.min(1, Math.max(0, (-rect.top) / total))
            : Math.min(1, Math.max(0, (winH - rect.top) / (winH + rect.height)));
          var chars = sec.querySelectorAll(".logo-scroller-mark .ch");
          var content = sec.querySelector(".logo-scroller-content");
          var contentRect = content ? content.getBoundingClientRect() : rect;
          var isActive = contentRect.top <= winH && contentRect.bottom >= 0;
          // show mark once content enters viewport
          sec.classList.toggle("scroll-active", isActive);
          // reveal letters progressively until content center reaches viewport center
          var denom = (winH * 0.5) + (contentRect.height * 0.5);
          var charProg = denom > 0 ? (winH - contentRect.top) / denom : 0;
          charProg = Math.min(1, Math.max(0, charProg));
          var step = 1 / (chars.length + 1);
          chars.forEach(function (ch, i) {
            var threshold = (i + 1) * step;
            ch.style.transitionDelay = (i * 70) + "ms";
            ch.classList.toggle("in", charProg >= threshold);
          });
          // slide secondary VOXEL text horizontally
          var slides = sec.querySelectorAll(".logo-scroller-slide");
          slides.forEach(function (sl) {
            var speed = parseFloat(sl.dataset.slide) || 0.2;
            var amount = (prog - 0.5) * (window.innerWidth * (1 + speed));
            sl.style.transform = "translate3d(" + (-amount).toFixed(1) + "px,0,0)";
          });
        });
      }
      updateLogoScroll();
      window.addEventListener("scroll", updateLogoScroll, { passive: true });
      window.addEventListener("resize", updateLogoScroll);
    }

    /* ---------- FOOTER CINEMA VIDEO RESILIENCE ---------- */
    document.querySelectorAll(".footer-cinema-bg video").forEach(function (v) {
      var stop = function () { /* fallback gradient already in place */ };
      v.addEventListener("error", stop);
      // hide video element if no sources (we use animated gradient + image instead)
      if (!v.querySelector("source")) {
        v.style.display = "none";
      }
    });

    /* ---------- HERO VIDEO RESILIENCE ---------- */
    document.querySelectorAll(".hero-video-bg video").forEach(function (v) {
      // hide video element if it has no playable source (fallback to poster image)
      var src = v.querySelector("source");
      if (!src || !src.getAttribute("src")) { v.style.display = "none"; return; }
      v.addEventListener("error", function () { v.style.display = "none"; });
      v.addEventListener("loadeddata", function () { v.style.opacity = "1"; });
    });

    /* ---------- 12 / 24 DIAL EXPLAINER ---------- */
    (function () {
      var stage = document.getElementById("dialStage");
      if (!stage) return;

      // Build tick marks + numerals for both dials
      stage.querySelectorAll('[data-dial-marks]').forEach(function (wrap) {
        var count = parseInt(wrap.getAttribute("data-dial-marks"), 10) || 12;
        wrap.innerHTML = "";
        for (var i = 0; i < count; i++) {
          var m = document.createElement("span");
          m.className = "dial-mark" + (i % (count === 24 ? 6 : 3) === 0 ? " major" : "");
          m.style.transform = "translate(-50%, -555%) rotate(" + (i * (360 / count)) + "deg)";
          wrap.appendChild(m);
        }
        // numerals (3, 6, 9, 12) or (6, 12, 18, 24)
        var labels = count === 24 ? [6, 12, 18, 24] : [3, 6, 9, 12];
        labels.forEach(function (lbl) {
          var angle = (lbl / count) * 2 * Math.PI;
          var r = 38; // % of dial
          var x = 50 + r * Math.sin(angle);
          var y = 50 - r * Math.cos(angle);
          var n = document.createElement("span");
          n.className = "dial-num" + (lbl === count ? " gold" : "");
          n.style.left = x + "%";
          n.style.top = y + "%";
          n.textContent = lbl;
          wrap.appendChild(n);
        });
      });

      // Toggle buttons (12 / 24 / auto)
      var buttons = document.querySelectorAll(".dial-toggle [data-dial-mode]");
      var steps = document.querySelectorAll(".dial-step");
      var mode = "12";
      var paused = false;

      function applyState(state) {
        stage.classList.toggle("is-24", state === "24");
        steps.forEach(function (s) {
          s.classList.toggle("is-on", s.getAttribute("data-step") === state);
        });
      }
      function setActiveButton(which) {
        buttons.forEach(function (b) {
          var on = b.getAttribute("data-dial-mode") === which;
          b.classList.toggle("active", on);
          b.setAttribute("aria-selected", on ? "true" : "false");
        });
      }
      function setMode(m) {
        if (m === "auto") {
          paused = false;
          setActiveButton("auto");
          return;
        }
        mode = m;
        paused = true;
        applyState(m);
        setActiveButton(m);
      }
      buttons.forEach(function (b) {
        b.addEventListener("click", function () { setMode(b.getAttribute("data-dial-mode")); });
      });

      // Auto-cycle for a more dynamic feel (pause when user picks a fixed state)
      setInterval(function () {
        if (paused) return;
        mode = mode === "12" ? "24" : "12";
        applyState(mode);
      }, 3800);

      // animate hour hand subtly
      var hourHands = stage.querySelectorAll(".dial-hand.hour");
      var minuteHands = stage.querySelectorAll(".dial-hand.minute");
      var start = Date.now();
      function tick() {
        var t = (Date.now() - start) / 1000;
        hourHands.forEach(function (h, i) {
          var deg = (t * 6 + (i === 1 ? 90 : 0)) % 360;
          h.style.transform = "translate(-50%, -100%) rotate(" + deg + "deg)";
        });
        minuteHands.forEach(function (m, i) {
          var deg = (t * 72 + (i === 1 ? 180 : 0)) % 360;
          m.style.transform = "translate(-50%, -100%) rotate(" + deg + "deg)";
        });
        requestAnimationFrame(tick);
      }
      tick();
    })();

    /* ---------- CUSTOM CURSOR (precision crosshair) ---------- */
    (function () {
      if (!window.matchMedia) return;
      var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      if (!canHover) return;

      var cursor = document.querySelector(".vx-cursor");
      if (!cursor) return;

      var tx = -100, ty = -100, x = -100, y = -100;
      var INTERACTIVE = "a, button, input, textarea, select, label, [role='tab'], [role='button'], [data-magnetic], .dial-toggle button, .nav-toggle, .theme-toggle, .acc-head, summary";

      document.addEventListener("mousemove", function (e) {
        tx = e.clientX; ty = e.clientY;
      }, { passive: true });

      // smoothed follow — width 24 / center offset 12
      function follow() {
        x += (tx - x) * 0.32;
        y += (ty - y) * 0.32;
        cursor.style.transform = "translate3d(" + (x - 12) + "px, " + (y - 12) + "px, 0)";
        requestAnimationFrame(follow);
      }
      follow();

      // hover state — interactive elements
      document.addEventListener("mouseover", function (e) {
        var t = e.target;
        if (t && t.closest) {
          cursor.classList.toggle("is-interactive", !!t.closest(INTERACTIVE));
        }
      });

      // press states
      document.addEventListener("mousedown", function () { cursor.classList.add("is-down"); });
      document.addEventListener("mouseup", function () { cursor.classList.remove("is-down"); });

      // hide when leaving the window
      document.addEventListener("mouseleave", function () { cursor.style.opacity = "0"; });
      document.addEventListener("mouseenter", function () { cursor.style.opacity = "1"; });
    })();

    /* ---------- KINETIC PACKSHOT (Edition 01 hero) ---------- */
    (function () {
      var stage = document.querySelector("[data-packshot-stage]");
      var core = document.querySelector("[data-packshot]");
      if (!stage || !core) return;

      var wrap = core.querySelector(".packshot-img-wrap");
      var halo = core.querySelector(".packshot-halo");

      // hover-driven glow toggle: cross-fade alt image
      core.addEventListener("mouseenter", function () { core.setAttribute("data-glow", "on"); });
      core.addEventListener("mouseleave", function () { core.removeAttribute("data-glow"); });

      // mouse parallax (subtle, only on fine pointer devices)
      if (window.matchMedia && window.matchMedia("(pointer: fine)").matches) {
        stage.addEventListener("mousemove", function (e) {
          var r = stage.getBoundingClientRect();
          var nx = ((e.clientX - r.left) / r.width) - 0.5;
          var ny = ((e.clientY - r.top) / r.height) - 0.5;
          if (wrap) {
            wrap.style.transform = "translate3d(" + (nx * 18) + "px, " + (ny * 14) + "px, 0) rotate3d(" + (-ny) + ", " + nx + ", 0, " + (Math.abs(nx) * 8) + "deg)";
          }
          if (halo) {
            halo.style.transform = "translate3d(" + (nx * 36) + "px, " + (ny * 28) + "px, 0)";
          }
        });
        stage.addEventListener("mouseleave", function () {
          if (wrap) wrap.style.transform = "";
          if (halo) halo.style.transform = "";
        });
      }

      // scroll-tied vertical drift + scale (within viewport range only)
      var rafToken = null;
      function onScroll() {
        if (rafToken) return;
        rafToken = requestAnimationFrame(function () {
          rafToken = null;
          var r = stage.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          // progress from -1 (above) to +1 (below)
          var p = ((r.top + r.height / 2) - (vh / 2)) / vh;
          if (p < -1.2 || p > 1.2) return;
          if (wrap) wrap.style.translate = "0 " + (p * -28) + "px";
          if (halo) halo.style.opacity = String(0.55 + (1 - Math.min(1, Math.abs(p))) * 0.45);
        });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    })();

    /* ---------- ANCHOR SMOOTH + form guard ---------- */
    document.querySelectorAll('form[data-demo]').forEach(function (f) {
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = f.querySelector("button");
        var input = f.querySelector("input");
        if (input && !input.value) { input.focus(); return; }
        if (btn) {
          var orig = btn.innerHTML;
          btn.innerHTML = "Added to the private list ✦";
          btn.disabled = true;
          if (input) input.value = "";
          setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 3200);
        }
      });
    });
  });
})();
